import 'bootstrap';
import '../src/utils/navbar';
import '../src/vendor/js-cookie/js.cookie';
import '../src/utils/cookie-alert';
import '../src/utils/livechat';
import '../src/utils/search';

document.addEventListener('DOMContentLoaded', () => {
  const contentNode = document.querySelector('body>.wrapper>.content-row');
  const footer = document.querySelector('footer');
  if (contentNode) {
    contentNode.style.minHeight = `calc(100vh - ${footer.clientHeight}px)`;
  }
});

window.app = {};
